"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMortgageLimitTable = void 0;
exports.defaultMortgageLimitTable = [
    {
        propertyValueMin: 0,
        propertyValueMax: 10000000,
        firstTime: true,
        maxLoanPercent: 90
    },
    {
        propertyValueMin: 0,
        propertyValueMax: 10000000,
        firstTime: false,
        maxLoanPercent: 80
    },
    {
        propertyValueMin: 10000001,
        propertyValueMax: 11250000,
        firstTime: true,
        maxLoanPercent: 90,
        maxLoanAmount: 9000000
    },
    {
        propertyValueMin: 10000001,
        propertyValueMax: 11250000,
        firstTime: false,
        maxLoanPercent: 80,
        maxLoanAmount: 9000000
    },
    {
        propertyValueMin: 11250001,
        propertyValueMax: 15000000,
        firstTime: true,
        maxLoanPercent: 80
    },
    {
        propertyValueMin: 11250001,
        propertyValueMax: 15000000,
        firstTime: false,
        maxLoanPercent: 80
    },
    {
        propertyValueMin: 15000001,
        propertyValueMax: 17150000,
        firstTime: true,
        maxLoanPercent: 70,
        maxLoanAmount: 12000000
    },
    {
        propertyValueMin: 15000001,
        propertyValueMax: 17150000,
        firstTime: true,
        maxLoanPercent: 80,
        maxLoanAmount: 12000000
    },
    {
        propertyValueMin: 15000001,
        propertyValueMax: 17150000,
        firstTime: false,
        maxLoanPercent: 70,
        maxLoanAmount: 12000000
    },
    {
        propertyValueMin: 15000001,
        propertyValueMax: 17150000,
        firstTime: false,
        maxLoanPercent: 80,
        maxLoanAmount: 12000000
    },
    {
        propertyValueMin: 17150001,
        propertyValueMax: 30000000,
        firstTime: true,
        maxLoanPercent: 70,
    },
    {
        propertyValueMin: 17150001,
        propertyValueMax: 30000000,
        firstTime: false,
        maxLoanPercent: 70,
    },
    {
        propertyValueMin: 30000001,
        propertyValueMax: Number.MAX_VALUE,
        firstTime: true,
        maxLoanPercent: 70
    },
    {
        propertyValueMin: 30000001,
        propertyValueMax: Number.MAX_VALUE,
        firstTime: false,
        maxLoanPercent: 70
    }
];
